angular.
module("dx.webapp.user").
factory("DxUser", function userService(
	$http,
	$q
) {
	"use strict";

	function User(data) {
		angular.extend(this, {
			// User properties
			id: 0,
			email: [""],
			firstName: "",
			lastName: "",
			communicationTerms: true,
			communicationSystem: true,
			communicationProductUpdates: false,
			communicationPromotional: false,
			gettingStartedGuideDisabled: false,

			load: function load(id) {
				var uId = id;
				if (!uId) {
					uId = "me";
				}
				var self = this;
				return $http.get("/user/" + uId).then(function success(response) {
					if (!response.data.faults) {
						angular.extend(self, response.data);
						return self;
					}
					return $q.reject(response);
				});
			},
			update: function update() {
				return $http.post("/user/update/", this).then(function success(response) {
					return response.data;
				});
			},
			changePassword: function changePassword(oldPw, newPw, id) {
				var uId = id;
				if (!uId) {
					uId = "me";
				}
				return $http.post("/user/changepassword/" + uId, {password: oldPw, newPassword: newPw}).then(function success(response) {
					return response.data;
				});
			},
			deleteUser: function deleteUser(id) {
				return $http.delete("/api/v1/users?userIds=" + id).then(function success(response) {
					return response.data;
				});
			},

			// Helper methods
			name: function name() {
				return this.firstName + " " + this.lastName;
			},
		});

		if (data !== null) {
			angular.extend(this, data);
		}
	}

	return User;
});
